import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Anchor, FlatBox } from '@zooplus/ui-components';
import { useTranslation } from 'react-i18next';
import { ExperimentationContext, UserTrackingEvents } from './context/ExperimentationContext';
import classNames from 'classnames';

const PhoneNumberSection: React.FC = () => {
  const { t } = useTranslation();
  const experimentation = useContext(ExperimentationContext);
  const [isPhoneNumberHidden, setPhoneNumberHidden] = useState(false);
  const phoneNumbersText = t('footer.hotline.phone_number');
  const phonesNumbersTextSplit = phoneNumbersText.split(',').map((item) => item.trim());
  const phoneNumberAnchor = (phoneNumber: String, phoneSectionText: String) => (
    <Anchor href={'tel:' + phoneNumber}>{phoneSectionText}</Anchor>
  );

  useEffect(() => {
    setPhoneNumberHidden(experimentation.isPhoneNumberHidden());
  }, [experimentation]);

  const onCallUsClicked = useCallback(() => {
    setPhoneNumberHidden(false);
    experimentation.trackClick(UserTrackingEvents.CF_CALL_US);
  }, [experimentation]);

  return (
    <div>
      <div
        data-test="contactForm.phoneNumberSection.phone_numbers"
        className={classNames('phoneNumberSection', {
          'phoneNumberSection--hidden': isPhoneNumberHidden,
        })}>
        {!!phoneNumbersText.length &&
          phonesNumbersTextSplit.map((phoneSectionText: string, index) => {
            const phoneNumber = phoneSectionText.replace(/\D+/g, '');
            return (
              <FlatBox variant="white" rounded className="pp-m-m phone-box" key={index}>
                {!!phoneNumber.length
                  ? phoneNumberAnchor(phoneNumber, phoneSectionText)
                  : phoneSectionText}
              </FlatBox>
            );
          })}
      </div>
      {isPhoneNumberHidden && (
        <FlatBox
          data-test="contactForm.phoneNumberSection.call_us"
          variant="white"
          rounded
          className="pp-m-m phone-box">
          <Anchor
            data-test="contactForm.phoneNumberSection.call_us.button"
            isBold
            className="pp-px-2xs"
            onClick={onCallUsClicked}>
            {t('footer.hotline.call_us')}
          </Anchor>
        </FlatBox>
      )}
    </div>
  );
};

export default PhoneNumberSection;
